import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js';
//import {  Validator } from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import moment from 'moment'
import {
	BasicSelect
} from 'vue-search-select'
import Multiselect from 'vue-multiselect'

export default {
	name: 'AutoBagOutHubConfiguration',
	components: {
		BasicSelect,
		Paginate,
		VueElementLoading,
		Multiselect
	},
	props: [],
	data() {
		return {
			hub:'',
			isLoading: false,
			isLoadingSearch: false,
			hubzoneid: '',
			HubID: '',
			hubname: '',
			showResulstHubSection: true,
			listSourceHubNameData: [],
			listHubZoneData: [],
			AutoBagOutHubsList: [],
			listSourceHubNameDataObj: {
				value: "",
				text: "",
				hubcode: ''
			},
			listHubZoneObjData: {
				value: "",
				text: ""
			},
			listHubZoneObjDataFlt: {
				value: "",
				text: ""
			},
			hubzoneidflt: '',
			isSearchHubZoneErr: 0,
			SearchHubZoneErr: '',
			addmodalShow: false,
			IsActive: false,
			hubLoading: '',
			pageCount: 0,
			pageNo: 0,
			fncAction: '',
			HubName:'',
			pageSize:10,
			pageIndex:0,
			actData: {},
			totalRows:0,
			listFltHubNameData:[],
			HubIDForFlt:0,
			HubNameForFlt:'',
			listFltHubNameDataObj: {
				value: "",
				text: "",
				hubcode: ''
			},
			HubIDArr:[],
			HubIDForFltArr:[]
		}
		
	},
	computed: {

	},
	filters: {
		moment: function(date) {
			if (date == null || date == '')
				return '--'
			return moment(date).format('DD-MM-YYYY');
		}
	},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.useremail = userdetail[0].email;
		this.hub = userdetail[0].HubId[0];
		this.getHubZoneData();
	},
	methods: {
		selectedHubzone(hubData) {
			this.listHubZoneObjData = hubData
			this.hubzoneid = hubData.value;
			this.hubzonename = hubData.text;
			this.listSourceHubNameDataObj = {
				text: '',
				value: '',
				hubcode: ''
			}
			this.HubID = ''
			this.HubIDArr=[]
			this.ConnectionID = ''
			this.$validator.reset()
			if (this.hubzoneid != undefined) {
				this.getSourceHubNameList(this.hubzoneid)
			}
		},
		selectedHubZoneFlt(hubData) {
			this.listHubZoneObjDataFlt = hubData
			this.hubzoneidflt = hubData.value;
			this.HubIDForFltArr=[]
			this.getZoneWiseAutoBagOutHubs();
			this.getFltHubNameList(this.hubzoneidflt);
		},
		selectedSourceHubName(selectedData) {
			this.HubID = ''
			this.ConnectionID = ''
			this.listSourceHubNameDataObj = selectedData
			this.HubID = selectedData.value;
			this.HubName = selectedData.text;
			this.$validator.validate('SourceHub')
		},
		selectedFltHubName(selectedData) {
			this.HubIDForFlt = ''
			this.ConnectionID = ''
			this.listFltHubNameDataObj = selectedData
			this.HubIDForFlt = selectedData.value;
			this.HubNameForFlt = selectedData.text;
			// this.$validator.validate('SourceHub')
		},
		getHubZoneData() {
			var self = this
			this.isLoading = true;
			var i = 0;
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({})
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'hubzone/list',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					self.isLoading = false;
					var listHubZoneData = result.data.ResponseData;
					for (i = 0; i < listHubZoneData.length; i++) {
						this.listHubZoneData.push({
							value: listHubZoneData[i].hubzoneid,
							text: listHubZoneData[i].hubzonename
						})
					}
				}, error => {
					self.isLoading = false;
					console.error(error)
				})
		},
		getSourceHubNameList() {
      this.hubLoading = 'Loading Hub...'
      this.listSourceHubNameData = [];
      var i = 0;
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      this.input = ({
        hubZoneId: this.hubzoneid
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'hubservicecenter/hub/list',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.hubLoading = ''
          var listSourceHubNameData = result.data.ResponseData;
          for (i = 0; i < listSourceHubNameData.length; i++) {
            this.listSourceHubNameData.push({
              value: listSourceHubNameData[i].HubID,
              text: listSourceHubNameData[i].HubCode + ' - ' + listSourceHubNameData[i].HubName + ' (' + listSourceHubNameData[i].HubID + ')',
              text1: listSourceHubNameData[i].HubName,
              hubcode: listSourceHubNameData[i].HubCode
            })
          }
        }, error => {
          console.error(error)
        })
    },

		getFltHubNameList() {
			this.hubLoading = 'Loading Hub...'
			this.listFltHubNameData = [];
			var i = 0;
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				hubZoneId: this.hubzoneidflt
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'hubservicecenter/hub/list',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					this.hubLoading = ''
					var listData = result.data.ResponseData;
					for (i = 0; i < listData.length; i++) {
						this.listFltHubNameData.push({
							value: listData[i].HubID,
							text: listData[i].HubCode + ' - ' + listData[i].HubName + ' (' + listData[i].HubID + ')',
							text1: listData[i].HubName,
							hubcode: listData[i].HubCode
						})
					}
				}, error => {
					console.error(error)
				})
		},

		getZoneWiseAutoBagOutHubs() {
			if(this.hubzoneidflt == "" || this.hubzoneidflt == undefined)
			{
				this.isSearchHubZoneErr = 1,
				this.SearchHubZoneErr = 'The HubZone field is required.'
				return false;
			}
            
			axios({
					method: 'GET',
					'url': apiUrl.api_url_hubops + 'getHubListForAutoBagOut?hubZoneId=' + this.hubzoneidflt + '&hubId=' +this.HubIDForFlt + '&pageIndex=' +this.pageIndex +'&pageSize=' +this.pageSize,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					self.isLoadingSearch = false;
					this.totalRows=0;
					if (result.data.ResultCode == 100) {
						this.AutoBagOutHubsList = result.data.ResponseData;
						this.totalRows=result.data.TotalCount;
						if (this.totalRows < 10) {
              this.pageCount = 1
            } else {
              this.pageCount = Math.ceil(this.totalRows / 10);
            }
					} else if (result.data.ResultCode == 101) {
						this.$alertify.error(result.data.ReturnMessage)
						this.AutoBagOutHubsList = '';
					}
				}, error => {
					self.isLoadingSearch = false;
					this.$alertify.error("Fetch Connection API error")
					console.error(error)
				})
		},
		saveAutoBagOutHubConfiguration() {
			this.input = ({
				hubId: this.HubID,
				lastModifiedBy: this.useremail,
				isActive :true,
				processLocationName: this.HubName
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'enableOrDisableAutoBagOut',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					self.isLoading = false;
					if (result.data.ResultCode == 100) {
						this.$alertify.success(result.data.ReturnMessage)
						this.resetForm();
					} else {
						// this.showResulstHubSection = false;
						this.$alertify.error(result.data.ReturnMessage)
					}
				}, error => {
					self.isLoading = false;
					this.$alertify.error('Save API Error')
					console.error(error)
				})
		},
		changeHubStatus(data) {
      var self = this
			if (data.isactive == true) {
				var status = false
			} else {
				var status = true
			}
      this.actData = ({
				hubId: data.hubid,
				lastModifiedBy: this.useremail,
				isActive :status,
				processLocationName: this.processlocationname
      })
      this.fncAction = 'saveAllocatedStatus'
      this.addmodalShow = true

    },
		saveAllocatedStatus(data){
			var self = this
      this.input = this.actData
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'enableOrDisableAutoBagOut',
					'data': this.actData,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					self.isLoading = false;
					if (result.data.ResultCode == 100) {
						this.$alertify.success(result.data.ReturnMessage)
						this.getZoneWiseAutoBagOutHubs();
						// this.showResulstHubSection = true;
					} else {
						// this.showResulstHubSection = false;
						this.$alertify.error(result.data.ReturnMessage)
					}
				}, error => {
					self.isLoading = false;
					this.$alertify.error('Save API Error')
					console.error(error)
				})
		},
		resetFlt() {
			this.listFltHubNameDataObj = {
				value: '',
				text: '',
				hubcode: ''
			}
			this.listFltHubNameData=[]
			this.HubIDForFlt=0
			this.HubNameForFlt=''
			this.AutoBagOutHubsList = []
			this.isLoadingSearch = false
			this.listHubZoneObjDataFlt = {
				value: "",
				text: ""
			}
			this.hubzoneidflt = ''
			this.isSearchHubZoneErr = 0
			this.SearchHubZoneErr = ''
			this.IsActive = false
			this.totalRows=0,
			this.HubIDForFltArr=[]
			
		},
		onSubmit: function() {
			this.$validator.validateAll()
				.then((result) => {
					if (!result) {
						return false;
					} else {
						this.saveAutoBagOutHubConfiguration();
					}
				}).catch(() => {
				});
		},
		resetForm() {
			this.HubName ='';
			this.listSourceHubNameDataObj = {
				value: '',
				text: '',
				hubcode: ''
			};
			this.listHubZoneObjData = {
				value: '',
				text: ''
			};
			this.listResultHubobjData = {
				value: '',
				text: ''
			};
				// this.showResulstHubSection = false;
				this.hubzoneid = '';
			this.HubID = '';
			this.connectiontype = '';
			this.connectionname = '';
			this.resultHubID = '';
			this.ConnectionID = '';
			this.$validator.reset();
			this.HubIDArr=[]
            this.listSourceHubNameData = [];
		},
		closeStatusModal() {
			this.addmodalShow = false;
		},
		takeAction() {
			this[this.fncAction]()
		},
		getPaginationData(pageNum) {
			this.pageIndex = (pageNum -1)
			this.getZoneWiseAutoBagOutHubs()
		}
	}
}



// WEBPACK FOOTER //
// ./src/views/components/AutoBagOutHubConfiguration/AutoBagOutHubConfiguration.js